/**
 * Product Carousel — keeps the pagination dots in sync with the
 * native scroll-snap track. Pure scroll + IntersectionObserver, no
 * timers, no scrollLeft polling.
 */
(function () {
  class ProductCarousel {
    constructor(section) {
      if (section.dataset.productCarouselInit === '1') return;
      section.dataset.productCarouselInit = '1';

      this.section = section;
      this.track = section.querySelector('[data-product-carousel-track]');
      this.dots = section.querySelectorAll('[data-product-carousel-dot]');
      this.slides = section.querySelectorAll('[data-product-carousel-slide]');
      if (!this.track || this.slides.length === 0) return;

      this.onDotClick = this.onDotClick.bind(this);

      this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const idx = Array.prototype.indexOf.call(this.slides, entry.target);
            if (idx >= 0) this.setActive(idx);
          });
        },
        {
          root: this.track,
          threshold: 0.6
        }
      );
      this.slides.forEach((slide) => this.observer.observe(slide));
    }

    onDotClick(e) {
      const idx = parseInt(e.currentTarget.dataset.productCarouselDot, 10);
      if (isNaN(idx)) return;
      const slide = this.slides[idx];
      if (!slide) return;
      slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }

    setActive(idx) {
      this.dots.forEach((dot, i) => {
        if (i === idx) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('.section-product-carousel')
      .forEach((sec) => new ProductCarousel(sec));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
